import { GridToolbarProps } from '@mui/x-data-grid';

export enum RegistrationRequestStatusEnum {
  NEW = 'NEW',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  EMAIL_VERIFICATION_PENDING = 'EMAIL_VERIFICATION_PENDING',
}

export type RegistrationRequestStatus =
  (typeof RegistrationRequestStatusEnum)[keyof typeof RegistrationRequestStatusEnum];

export type RegistrationRequest = {
  elements: RegistrationRequestItem[];
  total: number;
  totalPages: number;
  page: number;
  isFirst: boolean;
  isLast: boolean;
};

export type RegistrationRequestItem = {
  id: string;
  requestId?: string;
  createdDate: string;
  lastModifiedDate?: string | null;
  email: string;
  companyName: string;
  name: string;
  phoneNumber: string;
  requestedAccessApplication: string;
  requestedRole: string;
  status: RegistrationRequestStatus;
};

export type RegistrationRequestsToolbarProps = {
  onManageWhitelist?: () => void;
  total: number;
} & GridToolbarProps;

export type RequestStatus =
  | 'New'
  | 'In progress'
  | 'Received'
  | 'Resolved'
  | 'Reopened'
  | 'Canceled';

export type SupportRequest = {
  id: string;
  requestId?: string;
  submittedAt: string;
  name: string;
  assignedAdmin?: string | null;
  status: RequestStatus;
  category: string;
  description: string;
  resolutionComment?: string | null;
  ticketType: string;
  createDate: string;
  updatedAt: string | null;
  firstName: string;
  lastName: string;
  email: string;
  primaryEmail: string | null;
  phone: string;
  primaryPhone: string | null;
  message: string;
  startUtc?: string | null;
  endUtc?: string | null;
  issueNotTimeDependent: boolean;
  attachments?: Array<Attachment>;
  dcimDataCenterLocation?: string;
  dcimUrl?: string;
  dcimProfileId?: string;
  dcimDdidSample?: string;
};

export type Attachment = {
  id: string;
  name: string;
  error?: boolean;
  uploadedBy?: string;
  uploadedAt?: string;
  url?: string;
  downloadUrl?: string;
};

export interface SummaryItemConfig {
  icon: React.ReactNode;
  label: string;
  value: React.ReactNode;
}

export type SupportRequestsToolbarProps = {
  total: number;
} & GridToolbarProps;

export enum UserRequestsTab {
  Registration = 0,
  Support = 1,
  Intake = 2,
}
export enum IntakeRequestType {
  OnBoardIdp = 'onboard-idp',
  AdoptSsoApp = 'adopt-sso-app',
  IntegrateApi = 'integrate-api',
  Oidc = 'oidc',
  Saml = 'saml',
}

export interface IntakeRequestTypeOnBoardIdp {
  type: IntakeRequestType.OnBoardIdp;
  appName: string;
  idpType: string;
  contactEmails: string[];
}

export interface IntakeRequestTypeAdoptSsoApp {
  type: IntakeRequestType.AdoptSsoApp;
  appName: string;
  appType: string;
}

export interface IntakeRequestTypeIntegrateApi {
  type: IntakeRequestType.IntegrateApi;
  apiBaseUrls: string;
  apiSpecUris: string[];
  apiSpecFiles: string[];
  additionalNotes: string;
  gatewayBasePath: string;
  apiSpecVisibilityScope: string;
  corsConfiguration: string;
  environmentMapping: string;
  authenticationDetails: string;
  tokenValidationLocation: string;
  currentAuthorizationApproach: string;
  dxmAuthorizationLayer: boolean;
  exposeApiViaGateway: boolean;
  integrationType: string;
  loadTestingConsent: boolean;
  responsibleContacts: string;
  supportTeamEmails: string[];
  apiServerUris: string[];
  apiDocUris: string[];
}

export interface IntakeRequestTypeSsoConnector {
  type: IntakeRequestType.Oidc | IntakeRequestType.Saml;
  issuer: string;
  clientId: string;
  clientSecret: string;
}

export type IntakeRequest = {
  id: string;
  requestId: string;
  submittedAt: string;
  requestType: IntakeRequestType;
  name: string;
  email: string;
  status: RequestStatus;
  resolutionComment?: string | null;
  assignedAdmin?: string | null;
  description: string;
  ticketType: string;
  createDate: string;
  updatedAt: string | null;
  attachments?: Array<Attachment>;
  requestTypeDetails:
    | IntakeRequestTypeOnBoardIdp
    | IntakeRequestTypeAdoptSsoApp
    | IntakeRequestTypeIntegrateApi
    | IntakeRequestTypeSsoConnector;
};

export enum RequestCounterKey {
  SUPPORT = 'SUPPORT',
  INTAKE = 'INTAKE',
  SING_UP = 'SING_UP',
}

export interface NewCountResponse {
  counters: Record<RequestCounterKey, number>;
}
